module.exports = __webpack_public_path__ + "static/img/23.cc32e73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/23.jpg
// module id = lB6J
// module chunks = 16